import * as React from 'react';
import Button from '@sdk/components/ui/buttons/Button';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

export type Props = {
  onClick: () => Promise<string>;
  disabled?: boolean;
  inactive?: boolean;
  fontWeight?: 'bold' | 'semiBold';
  buttonType?: ButtonType;
  label: string;
};

const ButtonWrapper: React.FC<React.PropsWithChildren<Props>> = ({ label, ...props }) => (
  <Button {...props}>{label}</Button>
);

export default {
  ReactComponent: ButtonWrapper,
  bindings: {
    onClick: '&',
    disabled: '<?',
    inactive: '<?',
    fontWeight: '@?',
    buttonType: '@?',
    label: '@',
  },
};
